"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("./api/api");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  name: 'app',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: false
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var that, userId, pageId, template;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // 处理非PC端
            that = this;
            userId = that.$route.query.userId ? typeof that.$route.query.userId == 'string' ? that.$route.query.userId : that.$route.query.userId[0] : '';
            pageId = that.$route.query.pageId ? that.$route.query.pageId : '';
            template = that.$route.query.template ? that.$route.query.template : '';
            if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              _context.next = 8;
              break;
            }
            // 注册落地页
            if (that.$route.name == 'reg_first' || that.$route.name == 'reg_second' || that.$route.name == 'reg_third' || that.$route.name == 'regpage' || that.$route.name == 'landingpage') {
              window.location.href = that.$root.baseUrl + "/h5/vescort_wap/#/reg?pageId=" + pageId + '&template=' + template + '&userId=' + userId;
            } else if (that.$route.path == '/') {
              setTimeout(function () {
                if (that.$route.path.indexOf('/newslist') >= 0 && that.$route.query.isDetail == 'true') {
                  // 资讯详情
                  var ammid = that.$route.query.ammid ? that.$route.query.ammid : '';
                  window.location.href = that.$root.baseUrl + '/app/cargo/ammShareMain.app?id=' + ammid + '&type=1&userId=';
                } else if (that.$route.path.indexOf('/goodsdetail') >= 0) {
                  // 货源详情
                  var gsid = that.$route.query.gsid ? that.$route.query.gsid : '';
                  window.location.href = that.$root.baseUrl + '/app/cargo/ammShareMain.app?id=' + gsid + '&type=2&userId=';
                } else if (that.$route.path.indexOf('/cardetail') >= 0) {
                  // 车源详情
                  var vsid = that.$route.query.vsid ? that.$route.query.vsid : '';
                  window.location.href = that.$root.baseUrl + '/app/cargo/ammShareMain.app?id=' + vsid + '&type=3&userId=';
                } else {
                  // 其余跳转wap首页
                  window.location.href = that.$root.h5BaseUrl + "/h5/wap/#/";
                }
              }, 500);
            } else {
              // 其余跳转wap首页
              window.location.href = that.$root.h5BaseUrl + "/h5/wap/#/";
            }
            _context.next = 17;
            break;
          case 8:
            _context.prev = 8;
            _context.next = 11;
            return this.loadAdvertiseData();
          case 11:
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](8);
            console.log(_context.t0);
          case 16:
            that.isRouterAlive = true;
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[8, 13]]);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 获取顶部广告配置
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, userInfo, _yield$apiGetAdvertis, data, topAdverData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this; // session替换成cookie
              userInfo = (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')) : ''; // let userInfo = JSON.parse(window.sessionStorage.getItem('user'))
              _context2.next = 4;
              return (0, _api.apiGetAdvertiseData)({
                showType: 'PC_ALL',
                userId: userInfo ? userInfo.usid : ''
              });
            case 4:
              _yield$apiGetAdvertis = _context2.sent;
              data = _yield$apiGetAdvertis.data;
              if (data.proData.length > 0) {
                topAdverData = data.proData.filter(function (item) {
                  if (item.showPosition == 'TOP') return item;
                });
                window.localStorage.setItem('TOP', JSON.stringify(topAdverData));
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }()
  }
};